import { useAppSelector } from "../../hooks/use-app-selector.ts"

export const COMMUNICATION_TEMPLATES_PERMISSION =
  "communication.messages.communication_templates_manage" as const

export const COMMUNICATION_SEND_PERMISSION =
  "communication.messages.communication_send" as const

export const COMMUNICATION_BULK_SEND_PERMISSION =
  "communication.messages.communication_bulk_send" as const

export const COMMUNICATION_VIEW_ALL_PERMISSION =
  "communication.messages.communication_view_all" as const

export const COMMUNICATION_SETTINGS_PERMISSION =
  "communication.messages.communication_settings_manage" as const

export interface CommunicationRights {
  send: boolean
  bulkSend: boolean
  templates: boolean
  settings: boolean
  viewAll: boolean
}

export const useCommunicationRights = (): CommunicationRights => {
  const codes = useAppSelector(
    (state) => state.auth?.permissions?.codes?.communication?.messages
  )
  return {
    send: !!codes?.communication_send,
    bulkSend: !!codes?.communication_bulk_send,
    templates: !!codes?.communication_templates_manage,
    settings: !!codes?.communication_settings_manage,
    viewAll: !!codes?.communication_view_all
  }
}
